// extracted by mini-css-extract-plugin
export default {"customCol":"customCol---EzOqQ"};